<template>
        <div class="titolo-card">
          <h1>Gestione Documenti</h1>
          <h3>Qui troverai tutti i documenti inviati sia da noi che direttamente dall'utente.</h3>
        </div>

        <div class="documents-section">
    <h2>Documenti Allegati</h2>

    <div class="upload-controls">

<div class="file-upload">
  <label for="fileInput">Carica Documento:</label>
  <input 
    id="fileInput"
    type="file" 
    @change="uploadDocument" 
    accept="application/pdf, image/jpeg, image/png" 
    class="upload-input"
  />
</div>

<div class="permission-toggle">
  <label for="canUploadNutritionalFiles">Caricamento documenti nutrizionali:</label>
  <input
    type="checkbox"
    id="canUploadNutritionalFiles"
    v-model="canUploadNutritionalFiles"
    @change="updateCanUploadNutritionalFiles"
  >
</div>

<div class="permission-toggle">
  <label for="canUploadTechnicalFiles">Caricamento documenti tecnici:</label>
  <input
    type="checkbox"
    id="canUploadTechnicalFiles"
    v-model="canUploadTechnicalFiles"
    @change="updateCanUploadTechnicalFiles"
  >
</div>


</div>



    <!-- Tabella documenti caricati -->
    <table v-if="documents.length" class="documents-table">
      <thead>
        <tr>
          <th>Nome File</th>
          <th>Caricato Da</th>
          <th>Categoria</th>
          <th>Data Caricamento</th>
          <th>Visibilità Profilo</th>
          <!--<th>Azioni</th>-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(doc, index) in documents" :key="index">
          <td><a :href="doc.fileUrl" target="_blank" class="document-link">{{ doc.fileName }}</a></td>
          <td>{{ doc.uploadUser }}</td>
          <td>
  <select v-model="doc.uploadCategory" @change="updateUploadCategory(doc)">
    <option value="Alimentazione">Alimentazione</option>
    <option value="Tecnico">Tecnico</option>
    <option value="Generico">Generico</option>
  </select>
</td>

          <td>{{ formatDate(doc.uploadedAt) }}</td>
          <td>
                  <select 
                    v-model="doc.visibilityProfile" 
                    @change="updateVisibilityProfile(doc)"
                    class="visibility-select"
                  >
                    <option :value="true">Visibile</option>
                    <option :value="false">Non Visibile</option>
                  </select>
                </td>
          <!--<td>
            <button 
              @click="deleteDocument(doc.id)" 
              class="delete-button">
              Elimina
            </button>
          </td>-->
        </tr>
      </tbody>
    </table>

    <!-- Messaggio se non ci sono documenti -->
    <p v-else class="no-documents">Nessun documento caricato per questo utente.</p>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import {
  getFirestore,
  collection,
  query,
  where,
  getDoc,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

export default {
  props: {
    userId: {
      type: String,
      required: true,
    },
  },

  methods: {
    formatDate(timestamp) {
  if (!timestamp) return "Data non disponibile";
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const options = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" };
  return date.toLocaleString("it-IT", options);
},

  },
  setup(props) {
    const documents = ref([]);
    const userEmail = ref("");
    const isLoading = ref(false);
    const canUploadNutritionalFiles = ref(false);
    const canUploadTechnicalFiles = ref(false);

    const hasActiveNutritionalTicket = async () => {
      const db = getFirestore();
      const ticketsRef = collection(db, "tickets");
      const q = query(ticketsRef, where("userId", "==", props.userId));
      const ticketsSnapshot = await getDocs(q);
      return ticketsSnapshot.docs.some((ticketDoc) => {
        const status = ticketDoc.data().status;
        return status === "Aperto" || status === "Non Risposto" || status === "Risposto";
      });
    };



    const updateUploadCategory = async (documentItem) => {
  try {
    const db = getFirestore();
    const docRef = doc(db, "documenti", documentItem.id);
    await updateDoc(docRef, { uploadCategory: documentItem.uploadCategory });
    alert("Categoria del documento aggiornata con successo!");
  } catch (error) {
    console.error("Errore durante l'aggiornamento della categoria del documento:", error);
    alert("Errore durante l'aggiornamento della categoria del documento.");
  }
};



    const fetchUserData = async () => {
  try {
    const db = getFirestore();
    const userRef = doc(db, "users", props.userId);
    const userSnapshot = await getDoc(userRef);

    if (userSnapshot.exists()) {
      const userData = userSnapshot.data();
      userEmail.value = userData.email || "Email non trovata";
      if (typeof userData.canUploadNutritionalFiles === "boolean") {
        canUploadNutritionalFiles.value = userData.canUploadNutritionalFiles;
      } else if (await hasActiveNutritionalTicket()) {
        canUploadNutritionalFiles.value = true;
        await updateDoc(userRef, { canUploadNutritionalFiles: true });
      } else {
        canUploadNutritionalFiles.value = false;
      }
      canUploadTechnicalFiles.value = userData.canUploadTechnicalFiles === true;
    } else {
      console.warn("Nessun utente trovato per questo userId:", props.userId);
    }
  } catch (error) {
    console.error("Errore durante il recupero dei dati utente:", error);
  }
};


  const updateCanUploadNutritionalFiles = async () => {
  try {
    const db = getFirestore();
    const userDocRef = doc(db, "users", props.userId);
    await updateDoc(userDocRef, {
      canUploadNutritionalFiles: canUploadNutritionalFiles.value
    });
    alert("Impostazioni di caricamento nutrizionale aggiornate con successo!");
  } catch (error) {
    console.error("Errore durante l'aggiornamento del caricamento nutrizionale:", error);
    alert("Errore nell'aggiornamento del caricamento nutrizionale.");
  }
};

  const updateCanUploadTechnicalFiles = async () => {
  try {
    const db = getFirestore();
    const userDocRef = doc(db, "users", props.userId);
    await updateDoc(userDocRef, {
      canUploadTechnicalFiles: canUploadTechnicalFiles.value
    });
    alert("Impostazioni di caricamento tecnico aggiornate con successo!");
  } catch (error) {
    console.error("Errore durante l'aggiornamento del caricamento tecnico:", error);
    alert("Errore nell'aggiornamento del caricamento tecnico.");
  }
};


    const fetchDocuments = async () => {
      try {
        const db = getFirestore();
        const docsRef = collection(db, "documenti");
        const q = query(docsRef, where("userId", "==", props.userId));
        const querySnapshot = await getDocs(q);

        documents.value = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      } catch (error) {
        console.error("Errore durante il recupero dei documenti:", error);
      }
    };

   
    const uploadDocument = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  if (file.size > 10 * 1024 * 1024) {
    alert("Il file supera i 10MB.");
    return;
  }

  // Verifica il tipo di file consentito
  const allowedFileTypes = ["pdf", "jpg", "jpeg", "png"];
  const fileType = allowedFileTypes.find((type) => file.type.includes(type));
  if (!fileType) {
    alert("Formato non supportato. Usa solo PDF, JPG, JPEG o PNG.");
    return;
  }

  try {
    isLoading.value = true;
    const storage = getStorage();
    const filePath = `documenti/${props.userId}/${file.name}`;
    const fileRef = storageRef(storage, filePath);

    // Caricamento su Firebase Storage
    await uploadBytes(fileRef, file);
    const fileUrl = await getDownloadURL(fileRef);

    // Salvataggio su Firestore con il campo statico 'uploadUser'
    const db = getFirestore();
    const docRef = collection(db, "documenti");
    const newDoc = await addDoc(docRef, {
      userId: props.userId,
      fileUrl,
      fileName: file.name,
      fileType,
      uploadedAt: new Date(),
      uploadUser: "Amministrazione", // Campo statico
      uploadCategory: "Generico", // Campo statico
      visibilityProfile: false, // Nuovo campo statico

    });

    // Aggiungi il documento alla lista locale
    documents.value.push({
      id: newDoc.id,
      fileUrl,
      fileName: file.name,
      fileType,
      uploadUser: "Amministrazione",
      uploadCategory: "Generico", // Campo statico
      visibilityProfile: false,
    });

    alert("Documento caricato con successo!");
  } catch (error) {
    console.error("Errore durante il caricamento:", error);
    alert("Errore nel caricamento del documento.");
  } finally {
    isLoading.value = false;
  }
};


const updateVisibilityProfile = async (documentItem) => {
  try {
    const db = getFirestore();
    const docRef = doc(db, "documenti", documentItem.id);
    await updateDoc(docRef, { visibilityProfile: documentItem.visibilityProfile });
    alert("Visibilità aggiornata con successo!");
  } catch (error) {
    console.error("Errore durante l'aggiornamento della visibilità:", error);
    alert("Errore durante l'aggiornamento della visibilità.");
  }
};



    const deleteDocument = async (docId) => {
      const docToDelete = documents.value.find((doc) => doc.id === docId);
      if (!docToDelete) return;

      if (!confirm("Sei sicuro di voler eliminare questo documento?")) return;

      try {
        const storage = getStorage();
        const fileRef = storageRef(storage, docToDelete.fileUrl);

        await deleteObject(fileRef);

        const db = getFirestore();
        const docRef = doc(db, "documenti", docId);
        await deleteDoc(docRef);

        documents.value = documents.value.filter((doc) => doc.id !== docId);

        alert("Documento eliminato con successo!");
      } catch (error) {
        console.error("Errore durante l'eliminazione del documento:", error);
        alert("Errore nell'eliminazione del documento.");
      }
    };

    onMounted(() => {
      fetchUserData();
      fetchDocuments();
    });

    watch(
      () => props.userId,
      (newUserId) => {
        if (newUserId) {
          fetchUserData();
          fetchDocuments();
        }
      },
      { immediate: true }
    );

    return {
      documents,
      userEmail,
      uploadDocument,
      deleteDocument,
      updateVisibilityProfile,
      isLoading,
      canUploadNutritionalFiles,
      canUploadTechnicalFiles,
      updateCanUploadNutritionalFiles,
      updateCanUploadTechnicalFiles,
      updateUploadCategory
    };
  },
};
</script>

<style scoped>


.upload-controls {
  display: flex;
  align-items: center; /* Allinea verticalmente i contenuti dei div */
  justify-content: space-between; /* Distanzia i contenuti uniformemente */
  padding: 10px 0; /* Aggiunge un po' di padding per evitare che sia troppo stretto */
}

.file-upload, .permission-toggle {
  display: flex;
  align-items: center; /* Assicura che label e input/select siano allineati verticalmente */
  flex-grow: 1; /* Assicura che entrambi i div prendano spazio equamente */
}

.file-upload label, .permission-toggle label {
  white-space: nowrap; /* Impedisce alla label di andare a capo */
  margin-right: 10px; /* Spazio tra la label e l'input/select */
}

.upload-input {
  width: 100%; /* Occupa tutto lo spazio disponibile nel suo container */
  max-width: 500px; /* Imposta un limite massimo per l'input, se necessario */
}

.permission-toggle {
  flex-basis: 50%; /* Assegna esplicitamente una larghezza iniziale */
  justify-content: flex-end; /* Allinea il contenuto a destra */
}


/* Personalizza il checkbox */
.permission-toggle input[type="checkbox"] {
  width: 25px; /* Larghezza del checkbox */
  height: 25px; /* Altezza del checkbox */
  cursor: pointer; /* Cambia il cursore quando l'utente passa sopra il checkbox */
  accent-color: #007BFF; /* Colore quando il checkbox è selezionato (funziona su molti browser moderni) */
}

/* Stile per il focus per migliorare l'accessibilità */
.permission-toggle input[type="checkbox"]:focus {
  outline: 2px solid #007BFF; /* Aggiunge un contorno per indicare il focus */
}

/* Stile opzionale per hover per aumentare l'interattività */
.permission-toggle input[type="checkbox"]:hover {
  filter: brightness(90%); /* Rende il checkbox leggermente più scuro quando l'utente passa sopra */
}


.titolo-card h1 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.documents-section {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.documents-section h2 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.documents-section input[type="file"] {
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.documents-section ul {
  list-style-type: none;
  padding: 0;
}

.documents-section li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 0.75rem;
}

.documents-section li a {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.documents-section li button {
  background-color: #dc3545;
  color: #fff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
}

.documents-section li button:hover {
  background-color: #c82333;
}
</style>
